<h2 mat-dialog-title>Terms and Conditions</h2>
<mat-dialog-content class="mat-typography">

  <h3 cdkFocusInitial>F&aacute;ilte Ireland </h3>
  <p>The F&aacute;ilte Ireland Festivals and Events Database is a database of the festivals and events being held,
    throughout Ireland.</p>
  <p>The information and images are gathered by F&aacute;ilte Ireland for the purpose of promoting festivals, special
    events and tourism in Ireland. These festivals and special events will feed into the <a
      href="https://www.failteireland.ie/en/info/list-your-business" target="_blank">F&aacute;ilte Ireland suite of websites</a> a
    smaller selection of events will be chosen, from time to time, for even wider profiling and promotion by
    F&aacute;ilte Ireland, through various online, print and other communication channels e.g. media bulletins,
    listings, press releases &amp; printed calendar.</p>
  <p>To assist in its efforts, <strong>a third party </strong>has been commissioned by F&aacute;ilte Ireland (the
    National Tourism Development Authority) to act on its behalf in the gathering of information for the Festival and
    Events Database.</p>
  <p><strong>The terms and conditions stated here are the conditions of F&aacute;ilte Ireland and this third party.
    </strong></p>

  <h3>No Participation Fees</h3>
  <p>There are <strong>no participation fees </strong>involved in the collection or use of this information.
    F&aacute;ilte Ireland will feature festivals and special events (that meet their database criteria) on
    their websites free of charge and will also selectively use information from the database in other ways, at no
    charge.</p>

  <h3>Consumer Protection Laws</h3>
  <ul style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>In Ireland, all business advertising and promotion is governed by consumer protection legislation enforced by
        the National Consumer Agency. This makes it an offence to make false or misleading claims about your goods,
        services and prices. It is therefore essential that all the information you submit to us is clear, accurate and
        is not open to misleading interpretation.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>If you do inadvertently give wrong information, you must point this out to the customer before any transaction
        takes place. However, you may be in breach of consumer protection legislation and liable to prosecution by the
        Competition &amp; Consumer Protection Commission <a href="http://www.ccpc.ie" target="_blank">www.ccpc.ie</a>
        for details. If there have been changes to your Festival/Event programme or to your event dates you should
        inform F&aacute;ilte Ireland immediately via <a href="mailto:nationalevents&#64;failteireland.ie"
          target="_blank">nationalevents&#64;failteireland.ie</a> quoting your unique event ID (from your event registration
        confirmation email).</p>
    </li>
  </ul>

  <h3>Checking your information before submitting it</h3>
  <ul style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>When you submit information through this online system you are authorising F&aacute;ilte Ireland and their
        designates to publish it. We only check information before it is published against the online application form
        you submit. We don&rsquo;t provide proofs in advance of publishing. It is therefore extremely important that you
        check all the information you provide prior to submitting it.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>F&aacute;ilte Ireland and the third party reserve the right to edit the information you provide us with in the
        interest of style, brevity, consistency, template compliance, context and accuracy.</p>
    </li>
  </ul>

  <h3>Provision of Photo Images</h3>
  <ul style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>By submitting photo(s) via this website you are agreeing to give permission to F&aacute;ilte Ireland to use the
        image(s) for promotional purposes AND for F&aacute;ilte Ireland to circulate the image(s) to other parties
        including, but not limited to: Tourism Ireland; domestic and international media; and domestic and international
        travel trade.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>In submitting images to this website, you guarantee to F&aacute;ilte Ireland that you have permission from the
        photographer and that they in turn have permission from any people who appear in the photos (photographers
        generally obtain this by asking people to sign a &lsquo;model release form&rsquo;), allowing the image to be
        used by F&aacute;ilte Ireland and other parties as above.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>F&aacute;ilte Ireland cannot guarantee that images used will be accredited.</p>
    </li>
  </ul>
  <h3>Errors, Omissions and Changes</h3>
  <ul style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>We take every care to ensure we present the information you provide us with accurately in all our promotions.
        F&aacute;ilte Ireland our third party cannot, however, accept responsibility for errors or omissions, but where
        such are brought to our attention we will amend the information where ever possible and as soon as possible.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>In the case of errors made to information being featured online on the Fáilte Ireland suite of websites we will
        correct the information as soon as possible (typically within 24 hours of being informed).</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>If there are changes to the event you submitted to us e.g event programme details, dates or times - you are
        required to inform us through the 'change request' form on this website. This form can be accessed from the home
        page of this website and from the main navigation bar at the top of website. Failure to present accurate
        information exposes organisers to potential legal action.</p>
    </li>
  </ul>
  <h3>Promoting your information/images directly and through our promotional partners</h3>
  <ul style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>When you submit information to us, this is provided directly to F&aacute;ilte Ireland to promote through their
        own promotional channels. F&aacute;ilte Ireland may also share the information provided, for promotional
        purposes, with relevant parties, including but not limited to: Tourism Ireland, domestic and international
        media; and domestic and international travel trade, who may in turn publish the information provided.</p>
    </li>
  </ul>
  <h3>F&aacute;ilte Ireland Tourism Content System Contributor Agreement</h3>
  <ul style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>When you submit festival and event information through this website you are also agreeing to F&aacute;ilte
        Ireland's Tourism Content System Contributor Agreement, a copy of which can be viewed here.</p>
    </li>
  </ul>
  <h3>Privacy Policy</h3>
    <p>
      Our privacy policy is an integral part of our terms and conditions. By using this website, you are agreeing to these privacy terms. We collect your contact details in order that we can sign you up to the Events Portal and contact you regarding this service. Please take a few moments to understand how we protect your privacy and how you can exercise your rights by understanding our <b>Data Protection Policy</b>. Our policy can be viewed <a href="http://www.failteireland.ie/Footer/Privacy-Policy.aspx"
      target="_blank">here</a>.
    </p>
  <h3>Acceptance of Information</h3>
  <p>F&aacute;ilte Ireland reserve the right to exclude any information that is not in compliance with its criteria or
    do not comply with the conditions above or stated on the participation forms.</p>
  <h3>QUERIES</h3>
  <p>If you have any queries in relation to the F&aacute;ilte Ireland and Events Database 2019, email <a
      href="mailto:nationalevents&#64;failteireland.ie" target="_blank">nationalevents&#64;failteireland.ie</a> Office hours are
    Monday to Friday 08.30hrs to 17.30hrs. (Note: If you have any queries regarding the commissioning of our third
    party, please contact F&aacute;ilte Ireland, 88-95 Amiens Street, Dublin 1. Tel. 01 884 7700).</p>
  <p>F&aacute;ilte Ireland all rights reserved</p>
  <h3>Tourism Content System Contributor Agreement</h3>
  <p><strong>TO CONTRIBUTORS TO THE TOURISM CONTENT SYSTEM</strong>, this Tourism Content System Data Contributor
    Agreement shall constitute the entire agreement between you and F&aacute;ilte Ireland governing your contribution to
    the Tourism Content System.</p>
  <p>By proceeding with entering an event for inclusion on our database of festivals you are accepting the conditions of
    Tourism Content System Data Contributor Agreement, you are indicating your consent to be bound by and become a party
    to this Tourism Content System Data Contributor Agreement</p>
  <ol>
    <li><strong>Interpretations</strong></li>
  </ol>
  <p>1.1 In this Tourism Content System Data Contributor Agreement the following terms shall have the following
    meanings:</p>
  <p>&ldquo;Agreement&rdquo; means this Tourism Content System Data Contributor Agreement, including the Contribution
    Capture Form, Contribution Methodology, the Notice and Takedown Policy, and any and all other F&aacute;ilte Ireland
    policy documentation expressly included herein by reference;</p>
  <p>&ldquo;Business Day&rdquo; means a day when banks are open for business in Ireland, excluding public holidays and a
    Saturday or a Sunday;</p>
  <p>&ldquo;Contribution&rdquo; means the provision, supply or contribution of Data by the Contributor to F&aacute;ilte
    Ireland for inputting into the Database, by way of submission of one or more Contribution Capture Forms and
    reference to &ldquo;Contributing&rdquo; and &ldquo;Contributed&rdquo; shall be construed accordingly;</p>
  <p>&ldquo;Contribution Capture Form&rdquo; means the form supplied to the Contributor by F&aacute;ilte Ireland, to be
    used by the Contributor in supplying Data to F&aacute;ilte Ireland for the purpose of input into the Database by
    F&aacute;ilte Ireland or a service provider of F&aacute;ilte Ireland, whether on one or more occasions during the
    Term;</p>
  <p>&ldquo;Contribution Methodology&rdquo; means the forms, policies and procedures operated by F&aacute;ilte Ireland
    applicable to the Contribution of Data, hosted at http://www.failteireland.ie, or such other website notified by
    F&aacute;ilte Ireland, which may be subject to revision by F&aacute;ilte Ireland from time to time during the Term
    and, accordingly reference to the Contribution Methodology shall mean the then current Contribution Methodology;</p>
  <p>&ldquo;Contributor&rdquo; or &ldquo;You&rdquo; means the person or entity who has agreed to submit and supply Data
    to F&aacute;ilte Ireland for input into and publication on the Database pursuant to and in accordance with this
    Agreement, further details in respect of whom shall be set out in the Contribution Capture Form, and reference to
    &ldquo;Contribution", "Contributing&rdquo;, &ldquo;Yours&rdquo; and related terms shall be constructed accordingly.
  </p>
  <p>&ldquo;Data&rdquo; means the information Contributed by the Contributor to F&aacute;ilte Ireland;</p>
  <p>&ldquo;Database&rdquo; means the database of tourist facilities, accommodation, tours, events, entertainment, and
    related Irish tourism matters, operated by F&aacute;ilte Ireland, who obtain the relevant information from a variety
    of private, voluntary and commercial entities and make it available to users through various channels, which forms
    part of TCS and in which F&aacute;ilte Ireland has invested material budget, resources and time and in which it
    holds valuable IPR;</p>
  <p>&ldquo;Default&rdquo; means any negligent error, omission, breach, or default (including, but not limited to,
    fundamental breach or breach of a fundamental term) of either Party, its employees, agents or sub-contractors in
    connection with or in relation to the subject matter of this Agreement, causing material loss or damage, and in
    respect of which such Party is liable to the other, but excluding, for the avoidance of doubt, minor or trivial
    matters;</p>
  <p>&ldquo;Effective Date&rdquo; means the date on which this Agreement is executed by the Parties, recorded
    electronically pursuant to your accepting this Agreement, in the manner set out herein;</p>
  <p>&ldquo;Intellectual Property Rights&rdquo; or &ldquo;IPR&rdquo; means any patents, trademarks, service marks,
    design rights (whether registerable or otherwise), domain names, applications for any of the foregoing, copyright,
    (including, without limitation copyright in software) moral rights, database rights (whether copyright in databases
    or database sui-generis rights), know-how, trade or business names and other similar rights or obligations whether
    registerable or not, in any country (including, but not limited to, Ireland);</p>
  <p>&ldquo;Ireland&rdquo; means Ireland excluding Northern Ireland;</p>
  <p>&ldquo;Notice and Takedown Policy&rdquo; means the F&aacute;ilte Ireland&rsquo;s policy applicable to the
    notification and takedown of Data in circumstances in which F&aacute;ilte Ireland becomes aware that the Data is
    illegal, defamatory, infringes third party rights, or otherwise contravenes the internal policies of F&aacute;ilte
    Ireland, hosted at http://www.failteireland.ie, or such other website notified by F&aacute;ilte Ireland&rsquo;s from
    time to time, which shall be subject to revision by F&aacute;ilte Ireland from time to time during the Term and,
    accordingly, reference to the Notice and Takedown Policy shall mean the then current Notice and Takedown Policy;</p>
  <p>&ldquo;Parties&rdquo; means the Contributor and F&aacute;ilte Ireland and reference to &ldquo;Party&rdquo; shall be
    construed accordingly;</p>
  <p>&ldquo;Syndication&rdquo; shall mean the F&aacute;ilte Ireland licence, on whatever basis and in whatever manner,
    of the whole or part of the data contained in the Database to third parties, on whatever terms deemed appropriate by
    F&aacute;ilte Ireland and reference to &ldquo;Syndicated&rdquo; shall be construed accordingly;</p>
  <p>&ldquo;TCS&rdquo; or &ldquo;Tourism Content System&rdquo; means the F&aacute;ilte Ireland operated Database,
    together with ancillary F&aacute;ilte Ireland and third party software, hardware and knowhow, which taken together
    constitute the TCS;</p>
  <p>&ldquo;Term&rdquo; means the term of this Agreement, as set out in Clause 8; and</p>
  <p>&ldquo;Website&rdquo; means any website operated by F&aacute;ilte Ireland, or any third party authorised by
    F&aacute;ilte Ireland from time to time during the Term., whether in whole or in part.</p>
  <p>1.2 In this Agreement the following interpretations shall apply:</p>
  <p>(a) the masculine shall include the feminine and vice-versa;</p>
  <p>(b) the singular shall include the plural and vice-versa;</p>
  <p>(c) in the event of any conflict inconsistency or ambiguity between the terms and conditions of this Agreement,
    whether the Contribution Methodology, Contribution Capture Form or Notice and Takedown Policy, the terms and
    conditions of Clause 1-10 shall prevail, to the extent of such conflict, inconsistency or ambiguity; and</p>
  <p>(d) reference to the Agreement shall mean the version of the Agreement governing a particular Contribution. As set
    out at Clause 2.9, F&aacute;ilte Ireland may revise the Agreement during the Term.</p>
  <ol start="2">
    <li><strong>DATA CONTRIBUTION</strong></li>
  </ol>
  <p>2.1 The Contributor notes the importance which F&aacute;ilte Ireland places on taking a valid licence to use IPR in
    the Data. Accordingly, the Contributor warrants and represents to F&aacute;ilte Ireland that:</p>
  <p>(a) as at the date of initial Contribution and thereafter during the term of Contribution, the IPR in Data vests in
    Contributor or a third party licensor to Contributor;</p>
  <p>(b) where IPR vests in Contributor, then, Contributor expressly agrees with the IPR related provisions of this
    Agreement, as set out in Clause 5;</p>
  <p>(c) where IPR does not vest in Contributor, then, the Contributor expressly warrants and represents that the Data
    is duly licensed to Contributor in a manner which allows the Contributor to grant a sub-licence of such IPR to
    F&aacute;ilte Ireland to use Data, as set out in Clause 5; and</p>
  <p>(d) it shall exercise all reasonable and necessary skill, care, and diligence in the performance of this Agreement;
  </p>
  <p>AND, it is expressly stated by F&aacute;ilte Ireland and noted by Contributor that any Contribution of Data is
    conditional on the foregoing Contributor warranties and representations.</p>
  <p>2.2 Subject to earlier termination of this Agreement in accordance with its terms, F&aacute;ilte Ireland hereby
    grants to the Contributor, during the Term, a limited, personal, non-exclusive, right to Contribute Data in
    accordance with the provisions of this Agreement. It is expressly noted that either Party may terminate the
    Agreement pursuant to Clause 8 and, in particular, either Party may terminate the Agreement, upon prior written
    notice, pursuant to Clause 8.2.</p>
  <p>2.3 As set out in the Contribution Methodology, Data Contributions are an interactive process, based:</p>
  <p>(a) in respect of initial Contributions, on and commencing with the initial Contributor submission of a
    Contribution Capture Form and concluding with Contributor approval of the TCS listing; and</p>
  <p>(b) in respect of revised or updated Contributions following initial Contribution, on and commencing with the
    Contributor&rsquo;s submission of the Contribution revisions and concluding with Contributor approval of the
    revisions;</p>
  <p>ACCORDINGLY, F&aacute;ilte Ireland has provided the Contributor with all reasonable and necessary means and
    opportunities to ensure the validity, accuracy and other necessary attributes of the Data, which the Contributor
    hereby acknowledges and agrees to comply with.</p>
  <p>2.4 The Contributor undertakes to use all reasonable endeavours to procure that:</p>
  <p>(a) Contributions are at all times accurate and up to date;</p>
  <p>(b) any material inaccuracies or errors in Data discovered (whether by F&aacute;ilte Ireland, the Contributor, or
    any third party) subsequent to Contribution shall be corrected as soon as possible and that the Data is kept up to
    date at all times;</p>
  <p>(c) Data is not unlawful, defamatory, libellous, discriminatory, or otherwise illegal and/or objectionable;</p>
  <p>(d) Data does not infringe or otherwise prejudice the proprietary rights, IPR, privacy or publicity rights of any
    third party; and</p>
  <p>(e) Contributed Data 1988 to 2018 and the General Data Protection Regulation (GDPR).</p>
  <p>2.5 The Contributor shall be solely responsible and liable for all opinions, estimates (e.g. in distance or time of
    travel), statements, recommendations, forecasts or comments made in the Data.</p>
  <p>2.6 The Contributor acknowledges that it is aware that Contributing the Data into the Database may from time to
    time be subject to certain statutory or other external regulations, conditions and restrictions, which the
    Contributor undertakes to comply with.</p>
  <p>2.7 As the essence of the Database is to provide a &lsquo;live-feed&rsquo; environment to the public, F&aacute;ilte
    Ireland cannot accept a general obligation to monitor use of, and contents of, the Database, howsoever and
    whatsoever, which the Contributor hereby notes and agrees with. However, F&aacute;ilte Ireland does agree to use
    reasonable endeavours to address any breach of this Agreement, any breach of law or breach of third party rights,
    where it is notified of such breach. Any such action shall be made in accordance with the Notice and Takedown Policy
    as further set out in Clause 3 , of which the Contributor is aware and hereby expressly consents to comply with.</p>
  <p>2.8 F&aacute;ilte Ireland reserves the right, from time to time, to withdraw or vary the Database, whatsoever and
    howsoever, in whole or in part, in accordance with its business and organisation requirements.</p>
  <p>2.9 F&aacute;ilte Ireland reserves to right to revise the Agreement terms and conditions during the Term, whether
    to cater for developments in TCS (for example, the inclusion of user generated content) or F&aacute;ilte Ireland
    policy decisions. In such event, all contributions involving or requiring conclusion of the Agreement shall be made
    pursuant to the then current version of the Agreement. The foregoing shall apply without prejudice to the position
    governing previous contributors and previous versions of the Agreement. Each time the Contributor Contributes Data,
    whether new or updated Data, it is and confirms its agreement to be governed by the terms and conditions of this
    Agreement.</p>
  <p>2.10 In accordance with this Agreement F &aacute;ilte Ireland may Syndicate Data to third parties. It is
    acknowledged by Contributor that third party websites may allow for user generated content and, in particular, user
    or contributor commentary in relation to listings, including potentially those of Contributor (&ldquo;UGC&rdquo;).
    It is acknowledged and agreed by Contributor that:</p>
  <p>(a) F&aacute;ilte Ireland will or will not decline to Syndicate Data based on the existence or non-existence of UGC
    on third party websites;</p>
  <p>(b) F&aacute;ilte Ireland does not control and/or operate third party websites and does not monitor third party
    websites. Accordingly, F&aacute;ilte Ireland has no knowledge of UGC on third party websites;</p>
  <p>(c) F&aacute;ilte Ireland shall have no responsibility to and/or liability to Contributor deriving from any third
    party website UGC; and</p>
  <p>(d) where Contributor elects, then, it may, at its discretion, terminate this Agreement pursuant to Clause 8,
    provided that, the provisions of Clause 8.6 shall apply in respect of then current Syndicated Data of Contributor.
  </p>
  <ol start="3">
    <li><strong>EDITORIAL POLICIES OF F&Aacute;ILTE IRELAND</strong></li>
  </ol>
  <p>3.1 The Parties agree as follows:</p>
  <p>(a) it is the policy of F&aacute;ilte Ireland not to upload Data to the Database, and to remove Data, which, it
    determines, in its sole discretion, to be in breach of Clause 2.4 or is otherwise fraudulent, threatening, obscene,
    objectionable or otherwise inconsistent with the policies of F&aacute;ilte Ireland as set out in its Contribution
    Methodology. Notwithstanding the foregoing, F&aacute;ilte Ireland does not, and the Contributor acknowledges that
    F&aacute;ilte Ireland does not, nor can it reasonably be expected to, actively monitor Contributions against such
    criteria; and</p>
  <p>(b) F&aacute;ilte Ireland reserves the right to edit the Data for the purpose of ensuring consistency of format and
    style with other data in the Database and for the purpose of complying with any internal F&aacute;ilte Ireland
    policies and editorial principles.</p>
  <p>3.2 In the event that any Data is removed from the Database in accordance the Notice and Takedown Policy, then, the
    Contributor shall be notified of such removal and shall be given an opportunity to object to such removal or
    otherwise make any submission to F&aacute;ilte Ireland, all as further set out in the Notice and Takedown Policy.
    F&aacute;ilte Ireland agrees to consider any such submissions in a fair, impartial and reasonable manner, but the
    decision of F&aacute;ilte Ireland shall in each case, be final and binding.</p>
  <p>3.3 Any removal of Data in accordance with the Notice and Takedown Policy shall be on a &ldquo;without
    prejudice&rdquo; basis and shall not constitute any admission of responsibility and/or liability on the part of
    F&aacute;ilte Ireland and/or any other party.</p>
  <ol start="4">
    <li><strong>CHARGES</strong></li>
  </ol>
  <p>4.1 As of the date of execution of this Agreement, no charge is payable for the Contributor&rsquo;s Contribution of
    Data to the Database. However, F&aacute;ilte Ireland reserves its rights in this regard. In the event that
    F&aacute;ilte Ireland subsequently decide to implement charges, during the Term, then, it shall notify the
    Contributors in advance. Where the Contributor does not wish to pay charges for the continued presence of its Data
    on the Database, then, it shall have the right to terminate this Agreement in accordance with the procedures set out
    at Clause 8, whereupon F&aacute;ilte Ireland shall remove the relevant Data from the Database.</p>
  <ol start="5">
    <li><strong>INTELLECTUAL PROPERTY RIGHTS</strong></li>
  </ol>
  <p>5.1 The Contributor acknowledges and agrees that:</p>
  <p>(a) by Contributing Data, it automatically and expressly grants F&aacute;ilte Ireland a royalty-free, perpetual,
    worldwide, irrevocable, non-exclusive, sub-licensable, licence to use, reproduce, modify, publish, edit, translate,
    distribute, perform and display, access, store, copy, make available to third parties, amend, process, update,
    delete, and otherwise generally deal in the Data in whole or in part, as it sees fit, subject only to the
    restriction that it act in good faith and in the interests of promoting tourism in Ireland, in any form, media or
    technology, whether now or hereafter developed. In addition to the foregoing, the Contributor hereby expressly
    authorises and licences F&aacute;ilte Ireland to sub-licence such rights, whether through one or more multiple tiers
    of sub-licences, by way of Syndication, solely for F&aacute;ilte Ireland&rsquo;s own benefit and account;</p>
  <p>(b) F&aacute;ilte Ireland has spent, and continues to spend, considerable time and resources on the selection and
    arrangement of the Database as an original intellectual creation. Accordingly, F&aacute;ilte Ireland owns valuable
    IPR (including copyright in database and the database sui generis right) in the selection and arrangement of the
    contents of the Database and in the electronic materials necessary for its operation, without prejudice to the
    rights (if any) of the various Data contributors in the contents of the Database; and</p>
  <p>(c) in addition to F&aacute;ilte Ireland&rsquo;s IPR, referred to in the foregoing sub-Clause (b) F&aacute;ilte
    Ireland has spent considerable time and resources to collect, collate, compile, reformat and verify the accuracy of
    the contents of the Database. Accordingly, F&aacute;ilte Ireland owns, controls or licenses the copyright in the
    contents of the Database and the Contributor shall not question or dispute the ownership by F&aacute;ilte Ireland of
    any such rights.</p>
  <ol start="6">
    <li><strong>CONFIDENTIAL INFORMATION</strong></li>
  </ol>
  <p>6.1 The Contributor agrees to keep confidential any information disclosed by F&aacute;ilte Ireland under this
    Agreement and agrees, during the Term and for a period of not less than sixty (60) months thereafter, not to use,
    other than for the purpose of performing this Agreement, or to disclose, whether directly or indirectly, to any
    third party, such information, other than as required to carry out the purposes of this Agreement.</p>
  <p>6.2 The provisions of Clause 6.1 shall not apply to confidential information which is in or becomes part of the
    public domain (otherwise than by breach of this Agreement) or was in the lawful possession of the Contributor prior
    to disclosure under this Agreement and was not unlawfully obtained, either directly or indirectly.</p>
  <ol start="7">
    <li><strong>LIABILITY MANAGEMENT</strong></li>
  </ol>
  <p>7.1 The aggregate liability of the Parties for all Defaults, whether in contract, tort, or otherwise, arising under
    or in relation to this Agreement, shall be subject to the following limitations and exclusions:</p>
  <p>(a) in respect of each Party, for death, personal injury, fraud (including fraudulent misrepresentation) or
    criminal actions, liability shall not be subject to limitation or exclusion;</p>
  <p>(b) subject to sub-Clause (a), in respect of the Contributor, for breach of obligations in respect of Clauses 2.1,
    2.4, 5, and 6, liability shall not be subject to limitation or exclusion. In this regard, Contributor shall
    indemnify and hold harmless F&aacute;ilte Ireland, upon demand, in respect of any claim, liability, proceedings,
    fines, damages and/or costs of any nature, whatsoever and howsoever arising, which may be made or accrue against
    F&aacute;ilte Ireland; and</p>
  <p>(c) subject to sub-Clause (a) and (b), in respect of both Parties, for direct loss or damage, whatsoever and
    howsoever arising, liability shall be subject to limitation, up to an amount, in aggregate of ten thousand euro
    (&euro;10,000), and, in addition, shall be subject to exclusion.</p>
  <p>7.2 Except as expressly set forth in this Agreement, all warranties, whether oral or written, express or implied,
    including, but not limited to, any warranties of fitness for purpose, description or quality, are hereby excluded,
    to the maximum extent permissible under applicable law.</p>
  <p>7.3 In no event, will either Party be liable to the other Party for any consequential or indirect loss or damage
    (including, for the avoidance of doubt, anticipated financial benefits, of such nature), howsoever arising under, or
    in connection with, or in relation to, this Agreement. Reference in this Clause 7 to exclusion of liability shall
    refer to this Clause 7.3.</p>
  <p>7.4 The Parties recognise the existence of one or more separate F&aacute;ilte Ireland contracts referring to
    specific subject matter to which the Parties may be party, including, but not limited to, participation in
    F&aacute;ilte Ireland accreditation schemes (the &ldquo;Specific Contracts&rdquo;). The Parties recognise and agree
    as follows:</p>
  <p>(a) liability of Parties arising pursuant to this Agreement and one or more Specific Contracts shall be separate
    matters, dealt with by each such agreement separately; and</p>
  <p>(b) notwithstanding the foregoing, in no event shall either Party be liable to the other pursuant to this Agreement
    and any one or more Specific Contracts in respect of a single cause of action.</p>
  <ol start="8">
    <li><strong>TERM AND TERMINATION</strong></li>
  </ol>
  <p>8.1 This Agreement shall take effect on the Effective Date and shall continue in full force and effect unless and
    until terminated by either Party pursuant to Clause 8.2-8.4 (the &ldquo;Term&rdquo;).</p>
  <p>8.2 The Agreement may be terminated by either Party, upon not less than thirty (30) days prior written notice to
    the other Party.</p>
  <p>8.3 The licence granted to F&aacute;ilte Ireland at Clause 5 may be terminated or suspended by F&aacute;ilte
    Ireland, upon not less than five (5) days prior written notice to the Contributor.</p>
  <p>8.4 The Agreement may be terminated on prior written notice by one Party, if the other Party has committed a breach
    of its obligations under this Agreement which is:</p>
  <p>(a) incapable of remedy, immediately on receipt of written notice to the other Party; or</p>
  <p>(b) is capable of remedy and the other Party fails to remedy such breach to the reasonable satisfaction of the
    first Party within thirty (30) days of receipt of a written notice specifying details of the breach.</p>
  <p>8.5 In the event of expiry or termination of this Agreement pursuant to this Clause 8, the Contributor&rsquo;s Data
    shall be removed from the Database within thirty (30) days, but the Contributor acknowledges and agrees that expiry
    or termination of this Agreement shall be without prejudice to Data which has been Syndicated prior to the date of
    expiry or termination, which Syndication shall continue in full force and effect subject to the terms and conditions
    of the applicable agreement between F&aacute;ilte Ireland and the relevant third party.</p>
  <p>8.6 The provisions of Clause 1, 2, 5, 6, 7, 8, 9 and 10 shall survive expiry of the Term or earlier termination of
    this Agreement, together with any other provisions intended by their nature to so survive.</p>
  <p>&nbsp;</p>
  <p>&nbsp;</p>
  <ol start="9">
    <li><strong>CORRUPT GIFTS, INVESTIGATIONS AND EVIDENCE </strong></li>
  </ol>
  <p>9.1 The Contributor shall not offer or give or agree to give any person employed or engaged by F&aacute;ilte
    Ireland any gift or consideration of any kind as an inducement or reward for doing or forbearing to do or for having
    done or forborne to do any act in relation to the obtaining or performance of this Agreement or any other agreement
    with F&aacute;ilte Ireland or for showing or forbearing to show favour or disfavour to any person in relation to
    this Agreement.</p>
  <p>9.2 The Contributor shall provide reasonable assistance to F&aacute;ilte Ireland in facilitating any audit,
    investigation, criminal investigation or enquiry by any duly authorised regulatory body or law enforcement agency to
    which F&aacute;ilte Ireland is subject (the &ldquo;Investigation&rdquo;). The Contributor shall be repaid any
    reasonable expenses incurred in giving any such assistance. The foregoing shall apply without prejudice to any
    discovery or other form of investigation required at law, which shall be a matter dealt with pursuant to and in
    accordance with applicable law.</p>
  <ol start="10">
    <li><strong>GENERAL</strong></li>
  </ol>
  <p>10.1 Compliance with applicable law in the conduct of its business is a matter within the sole and entire
    responsibility of the Contributor. It is recognised and agreed that Your contribution of Data does not and does not
    represent and shall not be interpreted by You, or represented by You to third parties, as representing any
    F&aacute;ilte Ireland approval, or other form of confirmation, as to whether or not you comply with applicable law.
  </p>
  <p>10.2 The Contributor shall not, without the prior written consent of F&aacute;ilte Ireland, assign or transfer this
    Agreement or any of its rights under this Agreement to any other person, firm or company.</p>
  <p>10.3 Failure or neglect by either Party to enforce at any time any of the provisions of this Agreement shall not be
    construed as being, nor shall be deemed to be, a waiver of the Party&rsquo;s rights hereunder, nor in any way affect
    the validity of the whole or any part of this Agreement, nor prejudice the Party&rsquo;s rights to take subsequent
    action.</p>
  <p>10.4 This Agreement constitutes the entire agreement and understanding between the Parties and supersedes and
    replaces any arrangements, representations (excluding fraudulent representations), understandings, promises or
    agreements made or existing between the Parties prior to the Effective Date, and constitutes the entire agreement
    and understanding between the Parties in relation to the subject matter hereof. The Parties each acknowledge that
    they have not relied in entering into this Agreement on any agreement, understanding or arrangement which is not
    expressly set forth in this Agreement. In addition, no standard terms and conditions of contract issued or operated
    by either Party shall apply to this Agreement, including the subject matter of the contract between the Parties
    reflected herein.</p>
  <p>10.5 Except as otherwise expressly provided in the Agreement, no communication from one Party to the other shall
    have any validity under this Agreement unless made in writing by or on behalf of F&aacute;ilte Ireland or the
    Contributor. For the purposes of this Clause 10.5 the address of each Party shall be as set out on the Contribution
    Capture Form. Any notice or other communication which either Party is required or authorised by the Agreement to
    serve on the other shall be sufficiently served if sent to the authorised representative of the other at the address
    specified herein: (i) by hand; or (ii) by registered post; or (iii) by facsimile transmission, confirmed by
    registered post or recorded delivery; or (iv) by electronic mail. Notices sent by registered post shall be deemed to
    be served three (3) Business Days following the day of posting. Notices sent by facsimile transmission shall be
    deemed to be served on the day of transmission if transmitted before 4:00 p.m. on a Business Day, receipt
    acknowledged, but otherwise on the next Business Day, provided that confirmation by registered post is sent the same
    day. Notices sent by electronic mail, where such is an established means of communication between the Parties, shall
    be deemed to be served on the day of transmission if transmitted before 4:00 p.m. on a Business Day, receipt
    acknowledged, but otherwise on the next Business Day. In all other cases, notices and other communications shall be
    deemed to have been served on the day they are actually received. For the purposes of the Electronic Commerce Act
    2000, the Parties consent to the use of electronic communications and electronic signatures, for all purposes under
    this Agreement.</p>
  <p>10.6 In the event that any or any part of the terms, conditions or provisions contained in this Agreement shall be
    determined by any competent authority to be invalid, unlawful or unenforceable to any extent, then, the relevant
    term, condition or provision shall to that extent be severed from the remaining terms, conditions and provisions,
    which shall continue to be valid and enforceable to the fullest extent permitted by law.</p>
  <p>10.7 This Agreement shall be governed and construed in all respects in accordance with the laws of Ireland and the
    Parties hereby submit to the exclusive jurisdiction of the Courts of Ireland under or in relation to this Agreement.
  </p>
  <h3>Contribution Methodology</h3>
  <p><strong>Forms</strong></p>
  <p>Content can only be submitted to F&aacute;ilte Ireland for inclusion on the TCS using one of the following:</p>
  <ol style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>F&aacute;ilte Ireland Content Contribution Form</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>F&aacute;ilte Ireland&rsquo;s Online Listing Tool (individual self-catering businesses and non-accommodation
        approved products)</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>F&aacute;ilte Ireland&rsquo;s Calendar of Festivals and Events Online portal.</p>
    </li>
  </ol>
  <p><strong>Policies</strong></p>
  <p>It is F&aacute;ilte Ireland policy that to be listed on any of its websites contributors must comply with the
    following minimum requirements:</p>
  <ol style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>A Contributor Agreement must be completed.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>A TCS listing will only be published when the following elements have been submitted to F&aacute;ilte Ireland
        using the appropriate contribution method:</p>
    </li>
    <ol style="margin-top: 0cm;">
      <li style="tab-stops: list 72.0pt;">
        <p>a short description of the business or event</p>
      </li>
      <li style="tab-stops: list 72.0pt;">
        <p>a long description of the business or event</p>
      </li>
      <li style="tab-stops: list 72.0pt;">
        <p>a photograph, which adequately represents the business or event</p>
      </li>
      <li style="tab-stops: list 72.0pt;">
        <p>up-to-date consumer contact details for the business or event.</p>
      </li>
    </ol>
    <li style="tab-stops: list 36.0pt;">
      <p>Your business complies with all applicable planning, tax, insurance (including public liability insurance)
        transportation (including licensing), safety, consumer protection and other legal and regulatory requirements.
      </p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>Blood sports including coursing or hunting are not promoted in any F&aacute;ilte Ireland publications.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>No content will be accepted if it discriminates against any sector of society. This includes but is not limited
        to any reference that could be considered discriminatory on the basis of gender, marital status, family status,
        sexual orientation, religion, age, disability, race or membership of the Traveller community.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>Complaints and copyright infringements are dealt with through F&aacute;ilte Ireland&rsquo;s Notice and Takedown
        Policy.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>F&aacute;ilte Ireland will give 14 days (two weeks) notice to operators of any organisational policy changes
        that may affect their listing. F&aacute;ilte Ireland&rsquo;s decisions on these policy changes are final and not
        subject to appeal.</p>
    </li>
  </ol>
  <h3>Procedures</h3>
  <p><strong>Apply for a new listing</strong></p>
  <ol style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>Potential contributor contacts F&aacute;ilte Ireland requesting a TCS listing.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>F&aacute;ilte Ireland or its authorised contractor supplies the appropriate Content Contribution Form to the
        potential contributor.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>Potential contributor must complete the Content Contribution Form and return it to the relevant contact
        (F&aacute;ilte Ireland or the authorised contractor) with appropriate image(s) of their business.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>When the appropriate Content Contribution Form has been received and meets the minimum listing criteria, a
        Contributor Agreement will be sent to the potential contributor.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>The potential contributor must accept the terms and conditions of the agreement before their listing can be
        published.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>If the Contributor Agreement is declined, the application for a new listing will be terminated.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>If the Contributor Agreement is accepted, F&aacute;ilte Ireland or its authorised contractor will contact the
        operator, inviting them to review their listing for accuracy and respond.</p>
    </li>
  </ol>
  <p><strong>Update an existing listing</strong></p>
  <ol style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>Contributor contacts F&aacute;ilte Ireland, or its authorised contractor requesting a change to their existing
        TCS listing and including:</p>
    </li>
    <ol style="margin-top: 0cm;">
      <li style="tab-stops: list 72.0pt;">
        <p>The Discoverireland.ie url/location of their listing</p>
      </li>
      <li style="tab-stops: list 72.0pt;">
        <p>Details of the changes to be made.</p>
      </li>
    </ol>
    <li style="tab-stops: list 36.0pt;">
      <p>F&aacute;ilte Ireland or its authorised contractor makes the requested change and contacts the contributor,
        inviting them to review their listing for accuracy.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>The operator will review the listing and respond to F&aacute;ilte Ireland or its authorised contractor.</p>
    </li>
  </ol>
  <h3>Take Down Policy</h3>
  <p>F&aacute;ilte Ireland operates a &lsquo;notice and takedown&rsquo; policy for the Tourism Content System (TCS).</p>
  <p>If you have any complaints or objections to material or content included on the TCS, or if you believe that it
    infringes any intellectual property that you hold, please contact <a href="mailto:weblistings&#64;failteireland.ie"
      target="_blank">weblistings&#64;failteireland.ie</a> with your name, email address, telephone number, a detailed
    description of your complaint and the url/location of the content in question.</p>
  <p>If your complaint concerns an infringement of an intellectual property right, you must:</p>
  <ol style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>confirm that you are the owner or a valid licensee of the intellectual property rights of the content in
        question.</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>establish whether intellectual property rights have actually been infringed by consulting an expert if
        required.</p>
    </li>
  </ol>
  <p>Where F&aacute;ilte Ireland receives a complaint, which, in its reasonable opinion, is accurate, or has the
    potential to be determined as accurate, it may remove the content which is the subject of the complaint pending an
    investigation. Any removal will be on a &ldquo;without prejudice&rdquo; basis and shall not constitute any admission
    of responsibility on the part of F&aacute;ilte Ireland or any other party.</p>
  <p>F&aacute;ilte Ireland will notify the contributor that a complaint has been received and content may be removed
    within two working days. The contributor will then be given an opportunity to respond to the complaint in writing
    within five working days.</p>
  <p>Upon making a final determination on the complaint, F&aacute;ilte Ireland may:</p>
  <ul style="margin-top: 0cm;">
    <li style="tab-stops: list 36.0pt;">
      <p>Reinstate the content;</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>Amend the content at its discretion;</p>
    </li>
    <li style="tab-stops: list 36.0pt;">
      <p>Permanently remove the content.</p>
    </li>
  </ul>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Close</button>
</mat-dialog-actions>